import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const CheckSuccessIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='64'
    height='64'
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='64' height='64' rx='32' fill='#052E16' />
    <rect
      x='8.5'
      y='8.5'
      width='47'
      height='47'
      rx='23.5'
      stroke='white'
      stroke-opacity='0.2'
    />
    <path
      d='M29.4999 35.7064L40.3324 25L42 26.6468L29.4999 39L22 31.5883L23.6664 29.9415L29.4999 35.7064Z'
      fill='#4ADE80'
    />
  </svg>
);

export default CheckSuccessIcon;
